import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-52265e66"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "page" };
const _hoisted_2 = {
    key: 3,
    class: "editor-wrapper"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_VideoPage = _resolveComponent("VideoPage");
    const _component_ContentLinkPage = _resolveComponent("ContentLinkPage");
    const _component_PDFPage = _resolveComponent("PDFPage");
    const _component_EditorBlockView = _resolveComponent("EditorBlockView");
    const _component_FriedCard = _resolveComponent("FriedCard");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_FriedCard, { class: "template-page" }, {
            default: _withCtx(() => [
                (_ctx.isPageType(_ctx.DocumentPageType.Video))
                    ? (_openBlock(), _createBlock(_component_VideoPage, {
                        key: 0,
                        page: _ctx.page
                    }, null, 8, ["page"]))
                    : (_ctx.isPageType(_ctx.DocumentPageType.ContentLink))
                        ? (_openBlock(), _createBlock(_component_ContentLinkPage, {
                            key: 1,
                            "content-link-block": _ctx.page.contentLinkBlock
                        }, null, 8, ["content-link-block"]))
                        : (_ctx.isPageType(_ctx.DocumentPageType.DocumentContent))
                            ? (_openBlock(), _createBlock(_component_PDFPage, {
                                key: 2,
                                class: "pdf-page",
                                page: _ctx.page,
                                "page-width": _ctx.pageWidth,
                                recipients: []
                            }, null, 8, ["page", "page-width"]))
                            : (_ctx.isPageType(_ctx.DocumentPageType.Editor))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                    _createVNode(_component_EditorBlockView, {
                                        "is-block-toggled": true,
                                        "merge-values": {},
                                        content: _ctx.editorContent,
                                        context: _ctx.Context.DocumentView
                                    }, null, 8, ["content", "context"])
                                ]))
                                : _createCommentVNode("", true)
            ]),
            _: 1
        })
    ]));
}
